import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { AlertTriangle, Clock, X, MessageCircle, CreditCard } from "lucide-react";

const API = window.location.origin;

export function InstallmentReminder() {
  const { user } = useAuth();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      if (!user) return;
      
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${API}/api/installment-payments/user-status`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (res.ok) {
          const data = await res.json();
          setPaymentStatus(data);
        }
      } catch (error) {
        console.error("Error fetching payment status:", error);
      }
      setLoading(false);
    };

    fetchPaymentStatus();
  }, [user]);

  // عدم عرض أي شيء إذا...
  if (loading || dismissed || !paymentStatus) return null;
  if (paymentStatus.status !== "installment_plan") return null;
  if (paymentStatus.installments_paid >= 3) return null;

  // معلومات الدفع - بدون رقم واتساب
  const paymentInfo = "أرسل طلب من داخل التطبيق للتواصل";

  // حساب الأيام المتبقية
  const nextPaymentDate = paymentStatus.next_payment_date;
  let daysUntilDue = null;
  let isOverdue = paymentStatus.is_overdue;
  let daysOverdue = paymentStatus.days_overdue || 0;

  if (nextPaymentDate && !isOverdue) {
    try {
      const nextDate = new Date(nextPaymentDate);
      const now = new Date();
      daysUntilDue = Math.ceil((nextDate - now) / (1000 * 60 * 60 * 24));
    } catch (e) {}
  }

  // إذا كان متأخر - عرض تحذير أحمر
  if (isOverdue) {
    return (
      <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 z-40 animate-fade-in-up">
        <Card className="bg-gradient-to-r from-red-600 to-red-700 border-red-500 shadow-lg shadow-red-500/20">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <div className="bg-red-500/30 p-2 rounded-full">
                <AlertTriangle className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-bold mb-1">تنبيه: قسط متأخر!</h3>
                <p className="text-red-100 text-sm mb-3">
                  القسط {paymentStatus.installments_paid + 1} متأخر منذ {daysOverdue} يوم.
                  يرجى الدفع لتجنب إيقاف الحساب.
                </p>
                <div className="flex gap-2">
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex-1">
                    <Button size="sm" className="w-full bg-white text-red-600 hover:bg-red-50">
                      <MessageCircle className="w-4 h-4 me-1" />
                      تواصل للدفع
                    </Button>
                  </a>
                  <Button 
                    size="sm" 
                    variant="ghost" 
                    className="text-white hover:bg-red-500/30"
                    onClick={() => setDismissed(true)}
                  >
                    <X className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // إذا كان القسط قادم خلال 14 يوم - عرض تذكير برتقالي
  if (daysUntilDue !== null && daysUntilDue <= 14) {
    return (
      <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 z-40 animate-fade-in-up">
        <Card className="bg-gradient-to-r from-amber-500 to-orange-500 border-amber-400 shadow-lg shadow-amber-500/20">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <div className="bg-amber-400/30 p-2 rounded-full">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-bold mb-1">تذكير بالدفع</h3>
                <p className="text-amber-100 text-sm mb-3">
                  تم تفعيل حسابك بنجاح.
                  <br />
                  الترخيص: <span className="font-bold">دائم</span>
                </p>
                <div className="flex gap-2">
                  <Button 
                    size="sm" 
                    variant="ghost" 
                    className="text-white hover:bg-amber-400/30"
                    onClick={() => setDismissed(true)}
                  >
                    <X className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // لا يوجد شيء لعرضه
  return null;
}
